/**
 * @returns { null | string }
 */
export default function (variant) {
  const weightVal = variant?.dimensions?.find(d => d.dimension.id === 'weight')?.value;
  return weightVal > 0
    ? weightVal + ' г'
    : null;
}
